import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mojitoIntegrationStatus',
  standalone: false
})
export class MojitoIntegrationStatusPipe implements PipeTransform {

  transform(status: string): { name: string, class: string, icon: string } {
    switch (status) {
      case 'None': {
        return {
          name: 'Sin sincronizar',
          icon: 'sync_disabled',
          class: 'subtle-grey',
        }
      }
      case 'Pending': {
        return {
          name: 'Pendiente',
          icon: 'sync',
          class: 'subtle-amber',
        }
      }
      case 'Integrated': {
        return {
          name: 'Sincronizado',
          icon: 'check_circle',
          class: 'subtle-green',
        }
      }
      case 'Failed': {
        return {
          name: 'Error',
          icon: 'error',
          class: 'subtle-red',
        }
      }
      default: {
        return {
          name: 'Desconocido',
          icon: 'help',
          class: 'subtle-grey',
        }
      }
    }
  }

}
